var ImageFormatProps;
(function (ImageFormatProps) {
    ImageFormatProps["small"] = "imageUrlSmall";
    ImageFormatProps["medium"] = "imageUrlMedium";
    ImageFormatProps["large"] = "imageUrlLarge";
})(ImageFormatProps || (ImageFormatProps = {}));
const teaserCountImageSize = {
    1: 'large',
    2: 'medium',
    3: 'small',
};
export { ImageFormatProps, teaserCountImageSize };
//# sourceMappingURL=constants.js.map